import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';
import type { MqttMessage } from '../types';
import { topicDataAtomFamily } from './subscriptionAtoms';
import {
  areTopicsEqual,
  createMultiTopicDebugLabel,
} from '../utils/subscriptionUtils';

export interface MultiTopicState<T = unknown> {
  [topic: string]: MqttMessage<T> | null;
}

export const multiTopicSubscriptionAtomFamily = atomFamily(
  (topics: string[]) => {
    const dataAtom = atom<MultiTopicState>((get) => {
      const data: MultiTopicState = {};

      for (const topic of topics) {
        data[topic] = get(topicDataAtomFamily(topic));
      }

      return data;
    });

    dataAtom.debugLabel = createMultiTopicDebugLabel(topics);

    return dataAtom;
  },
  areTopicsEqual,
);
